var map = {
	"app/pages/admin-area/admin-area.module": [
		"./src/app/pages/admin-area/admin-area.module.ts",
		"default~app-pages-admin-area-admin-area-module~app-pages-pages-module"
	],
	"app/pages/digital-workers/digital-workers.module": [
		"./src/app/pages/digital-workers/digital-workers.module.ts",
		"default~app-pages-digital-workers-digital-workers-module~app-pages-pages-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"default~app-pages-admin-area-admin-area-module~app-pages-pages-module",
		"default~app-pages-digital-workers-digital-workers-module~app-pages-pages-module",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;